import Joi from 'joi';

export const ADD_IPS = 'ipfabric/Settings/DiscoverySeed/ADD_IPS';
export const CLEAR_IPS = 'ipfabric/Settings/DiscoverySeed/CLEAR_IPS';
export const FETCH_IPLIST = 'ipfabric/Settings/DiscoverySeed/FETCH_IPLIST';
export const FETCH_HISTORY_SEEDS =
  'ipfabric/Settings/DiscoverySeed/FETCH_HISTORY_SEEDS';

export const ALLOWED_MASK_SEED_V4 = 24;
export const ALLOWED_MASK_SEED_V6 = 119;

export const schema = Joi.string().ip({
  version: ['ipv4'],
  cidr: 'optional',
});
